import script from "./vcheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./vcheckbox.vue?vue&type=script&setup=true&lang=js"

import "./vcheckbox.vue?vue&type=style&index=0&id=7fdbb1e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdbb1e3"]])

export default __exports__